import React from "react";

function DataTable() {
  return <div>Data Table</div>;
}

export default DataTable;
